export function isMobileDevice() {
    if (typeof window === 'undefined') return false;
    const uaMatch = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
    const coarse = typeof window.matchMedia === 'function'
        && window.matchMedia('(pointer: coarse)').matches;
    return uaMatch || coarse;
}
